module.exports = __webpack_public_path__ + "media/images/lp/1/achievement3-sp-5bb23e7ca297a8ec783449ddfd87b7ba.png";